export interface IOpportunitySimpleSummary {
  id: string;
  objective: string;
  remote: boolean;
}

export class OpportunitySimpleSummary {
  public id: string;
  public objective: string;
  public remote: boolean;

  constructor(data: IOpportunitySimpleSummary) {
    this.id = data.id;
    this.objective = data.objective;
    this.remote = data.remote;
  }
}
